<template>
  <!--  展会动态-->
  <div style="width: 100%;height: auto;display: flex;flex-direction: column;align-items: center;padding-top: 60px;">

    <Breadcrumb :value="[$t('h.tabName1'),$t('h.tabName2'),$t('h.tabName2Item3')]"/>
    <div style="width: 1200px;height: auto;padding-bottom: 60px;">
      <div style="display: flex;padding: 30px 20px;">
        <a-button-group>
          <a-button @click="tabChange(index)" v-for="(item,index) in tabData" :key="index"
                    :style="item.select ? 'color: #FFFFFF;background: #d7000F;border: none;':'color: #666666;background: transparent;border: 1px solid #DDDDDD;'"
                    style="width: 288px;height: 48px;font-family: SourceHanSansCN-Medium;font-size: 20px;">
            {{ item.label }}
          </a-button>
        </a-button-group>
      </div>
      <template v-if="tabIndex == 0">
        <div style="width: 1200px;display: flex;flex-direction: column;align-items: center;margin-top: 30px;">
          <template v-for="(item,index) in listDataNew">
            <div :key="index"
                 style="height: 205px;width: 1158px;margin: 12px 0;border-bottom: 1px #D8D8D8 solid;display: flex;cursor: pointer;"
                 @click="$router.push({path: '/dynamic-detail', query: {id: item.id}})">
              <div v-if="item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].coverImage"
                   style="width: 390px;height: 180px;margin-right: 24px;overflow: hidden;border-radius: 6px;">
                <img class="customImage" :src="item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].coverImage"/>
              </div>
              <div
                  style="width: 808px;display: flex;flex-direction: column;justify-content: space-between;padding-top: 8px;padding-bottom: 24px;">
                <div>
                  <div class="customLabel"
                       style="font-family: SourceHanSansCN-Medium;font-size: 18px;color: #444444;line-height: 24px;">
                    {{ item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].title }}
                  </div>
                  <div v-if="item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].content"
                       style="font-family: SourceHanSansCN-Medium;font-size: 16px;color: #8D8D8D;line-height: 22px;padding-top: 4px;">
                    {{ item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].content }}
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between;">
                  <div
                      style="width: 182px;height: 28px;background-image: linear-gradient(270deg, #FFFFFF 0%, #d7000F 100%);border-radius: 2px;padding: 0 12px;display: flex;align-items: center;color:white;">
                    {{ $moment(item.updateTime || item.createTime).format('YYYY-MM-DD') }}
                  </div>
                  <a-button class="customBtn"
                            style="width: 110px;height: 32px;border: none;background: #d7000F;display: flex;align-items: center;">
                    <div style="color: white;font-size: 14px;line-height: 14px;padding-right: 6px;">
                      {{ $t('h.dynamic.label') }}
                    </div>
                    <img style="width: 18px;height: 18px" src="@/assets/img/more-white.png"/>
                  </a-button>
                </div>
              </div>
            </div>
          </template>
          <div style="margin-top: 40px">
            <a-pagination v-model="newPageNo"  :show-total="newTotal => $t('h.total') + ' ' + newTotal + ' ' + $t('h.record')" :pageSize="newPageSize" :total="newTotal" show-less-items
                          class="myPagination" @change="handleNewPageChange"/>
          </div>
        </div>
      </template>
      <template v-else-if="tabIndex == 1">
        <div style="width: 1200px;display: flex;flex-direction: column;align-items: center;margin-top: 30px;">
          <template v-for="(item,index) in listDataFocus">
            <div :key="index"
                 style="height: 205px;width: 1158px;margin: 12px 0;border-bottom: 1px #D8D8D8 solid;display: flex;cursor: pointer;"
                 @click="$router.push({path: '/dynamic-detail', query: {id: item.id}})"
            >
              <div v-if="item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].coverImage"
                   style="width: 320px;height: 180px;margin-right: 24px;overflow: hidden;border-radius: 6px;">
                <img class="customImage" :src="item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].coverImage"/>
              </div>
              <div
                  style="width: 808px;display: flex;flex-direction: column;justify-content: space-between;padding-top: 8px;padding-bottom: 24px;">
                <div>
                  <div class="customLabel"
                       style="font-family: SourceHanSansCN-Medium;font-size: 18px;color: #444444;line-height: 24px;">
                    {{ item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].title }}
                  </div>
                  <div v-if="item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].content"
                       style="font-family: SourceHanSansCN-Medium;font-size: 16px;color: #8D8D8D;line-height: 22px;padding-top: 4px;">
                    {{ item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].content }}
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between;">
                  <div
                      style="width: 182px;height: 28px;background-image: linear-gradient(270deg, #FFFFFF 0%, #d7000F 100%);border-radius: 2px;padding: 0 12px;display: flex;align-items: center;color:white;">
                    {{ $moment(item.updateTime || item.createTime).format('YYYY-MM-DD') }}
                  </div>
                  <a-button class="customBtn"
                            style="width: 110px;height: 32px;border: none;background: #d7000F;display: flex;align-items: center;">
                    <div style="color: white;font-size: 14px;line-height: 14px;padding-right: 6px;">
                      {{ $t('h.dynamic.label') }}
                    </div>
                    <img style="width: 18px;height: 18px" src="@/assets/img/more-white.png"/>
                  </a-button>
                </div>
              </div>
            </div>
          </template>
          <div style="margin-top: 40px">
            <a-pagination v-model="focusPageNo" :show-total="focusTotal => $t('h.total') + ' ' + focusTotal + ' ' + $t('h.record')" :pageSize="focusPageSize" :total="focusTotal" show-less-items
                          class="myPagination"
                          @change="handleFocusPageChange"/>
          </div>
        </div>
      </template>
	  <template v-else>
	          <!-- EDM静态数据内容 -->
	          <div style="width: 1200px;display: flex;flex-direction: column;align-items: center;margin-top: 30px;">
	            <template v-for="(item,index) in filteredEDMData">
	              <div :key="index"
	                   style="height: 180px;width: 1158px;margin: 12px 0;border-bottom: 1px #D8D8D8 solid;display: flex;cursor: pointer;"
	                   @click.stop="handleEDMClick(item)">
	                <div
	                    style="width: 100%;display: flex;flex-direction: column;justify-content: space-between;padding: 16px 0;">
	                  <div>
	                    <div class="customLabel"
	                         style="font-family: SourceHanSansCN-Medium;font-size: 18px;color: #444444;line-height: 24px;">
	                      {{ item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].title }}
	                    </div>
	                    <div
	                        style="font-family: SourceHanSansCN-Medium;font-size: 16px;color: #8D8D8D;line-height: 22px;padding-top: 4px;">
	                      {{ item[$language === 'ZH' ? 'itemsCn' : 'itemsEn'].content }}
	                    </div>
	                  </div>
	                  <div style="display: flex;align-items: center;justify-content: space-between;">
	                    <div
	                        style="width: 182px;height: 28px;background-image: linear-gradient(270deg, #FFFFFF 0%, #d7000F 100%);border-radius: 2px;padding: 0 12px;display: flex;align-items: center;color:white;">
	                      {{ $moment(item.updateTime || item.createTime).format('YYYY-MM-DD') }}
	                    </div>
	                    <a-button class="customBtn"
	                              style="width: 110px;height: 32px;border: none;background: #d7000F;display: flex;align-items: center;">
	                      <div style="color: white;font-size: 14px;line-height: 14px;padding-right: 6px;">
	                        {{ $t('h.dynamic.label') }}
	                      </div>
	                    </a-button>
	                  </div>
	                </div>
	              </div>
	            </template>
	          </div>
	        </template>
    </div>
  </div>
</template>

<script>
import {queryArticlePageList} from "@/assets/api";
import {nextTick} from "vue";

export default {
  name: "Dynamic",
  data() {
    return {
      tabIndex: 0,
      newPageNo: 1,
      newPageSize: 10,
      newTotal: 0,
      focusPageNo: 1,
      focusPageSize: 10,
      focusTotal: 0,
      loadingNew: false,
      loadingFocus: false,
      tabData: [
        {
          label: this.$t('h.dynamic.btn1'),
          select: true
        },
        {
          label: this.$t('h.dynamic.btn2'),
          select: false
        },
		// {
  //         label: this.$t('h.dynamic.btn3'), // 添加EDM标签
  //         select: false
  //       }
      ],
      listDataNew: [],
      listDataFocus: [],
      allListDataNew: [],
      allListDataFocus: [],
      listDataEDM: [ // 静态EDM数据，支持中英文
              {
                id: 'edm1',
                itemsCn: {
                  title: '【WireShow 2025】WireShow 2025 汇聚智造解决方案，立即注册，8月共话线缆数字化未来',
                  content: '作为国民经济重要基础产业的线缆行业，正积极拥抱数字化浪潮。本届展会将聚焦数智创新，集中展示智能制造装备、工业软件等全链条解决方案，为线缆企业实现从“制造”迈向“智造”的转型升级提供技术参考和合作机遇。',
                  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=894e31e6-2717-418e-a5d9-7df87ba4ea8c'
                },
                itemsEn: {
                  title: 'Register Now to Discover Smart Wire & Cable Manufacturing Solutions！Meet You at WireShow 2025 in August ,Shanghai ,China',
                  content: 'WireShow 2025 will focus on digital and intelligent innovation, presenting end-to-end solutions across the entire value chain—from smart manufacturing equipment to industrial software. The event will offer wire & cable manufacturers valuable technical insights and partnership opportunities to accelerate their transition from traditional manufacturing to smart manufacturing.',
                  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=ac9db6fd-0e48-41fd-bf9d-3e29990612f8'
				},
                updateTime: '2025-06-03',
              },
              {
                id: 'edm2',
                itemsCn: {
                  title: '【WireShow 2025】700+参展企业，57，500平方米展示面积，30+专业技术交流会！8月27日-29日，与40，000+线缆行业同仁共赴行业盛宴',
                  content: 'WireShow 2025预计将以57,500平方米展示面积汇聚海内外700+参展企业。WireShow 2025招展工作进展顺利，已吸引众多品牌展商报名参展',
				  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=4fbe1c70-2f42-47b8-a24d-67f8c7c84812'
                },
                itemsEn: {
                  title: '700+ exhibitors, 57,500sq.m. exhibition space, 30+ industry forums and conferences, Register now to meet over 40,000 global industry partners at WireShow 2025 in August ,Shanghai ,China',
                  content: 'WireShow 2025, covering an exhibition space of 57,500 square meters, is expected to bring together more than 700 exhibitors from both China and abroad. ',
				  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=d734521a-6b7d-4ed3-9e78-8f756bd98ba7'
                },
                updateTime: '2025-5-15',
              },
			  {
			    id: 'edm3',
			    itemsCn: {
			      title: '【WireShow 2025】呈现线缆生产、检测、应用的全领域产品、技术及解决方案，8月上海遇见线缆精彩！',
			      content: 'WireShow 2025特别规划了5大产品主题路线，包括“数智赋能创新装备”、“绿色低碳解决方案”、“品质线缆线材”、“辅助加工配套”及“精准测控技术”，完整覆盖线缆生产、检测、应用的全领域解决方案。',
			  	  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=1b58028c-f642-4bc9-b6ad-b05c6abfec70'
			    },
			    itemsEn: {
			      title: 'Cable production, inspection, and application.... Seize the business opportunity in WireShow ，Shanghai,China',
			      content: 'WireShow 2025 has specially planned five product routes, including "Digital and Intelligent Empowerment for Innovative Machinery", "Green and Low-Carbon Solutions", "High-quality Wires & Cables", "High-performance Technology Tools & Auxiliary Materials" and "High-precision Measuring & Control Technology / Test Engineering". The cable  & wire production, testing, application of the whole field o f solutions are completely covered. ',
			  	  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=408057b9-2bd7-499b-b106-134b50fa0ce4'
			    },
			    updateTime: '2025-4-30',
			  },
			  {
			    id: 'edm4',
			  	itemsCn: {
			  	  title: '【WireShow 2025】数字经济发展动能强劲，人形机器人产业加速狂飙！8月27日-29日，中国国际线缆工业展览会为您带来创新设备、材料等产品、技术及解决方案',
			  	  content: '近年来，高速铜缆（Twinax电缆）连接器受到广泛关注；人形机器人在工业、消防、养老等领域的应用，均被市场寄托了较高的期待。海内外参展商陆续加入本届展会，将在本届展会展示相关最新产品。',
			  	  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=8e3958be-0872-4274-9b16-2cfd6aa3cdba'
			  	},
			  	itemsEn: {
			  	  title: 'Artificial intelligence, new materials, commercial aerospace.... Seize the business opportunity at WireShow',
			  	  content: "AI seen as key to high-quality growth China's emphasis on advancing the application of fast-evolving artificial intelligence technology in a wide range of industries will inject new momentum into the country's high-quality economic growth and create enormous opportunities for multinational corporations to invest in the country.Domestic and overseas exhibitors have been joining this exhibition one after another and will showcase their latest products at this event.",
			  	  link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=a4c79940-0187-4b06-8e04-5c3cd31cacb4'
			  	},
			  	updateTime: '2025-4-10',
			  	},
				{
				  id: 'edm5',
				  itemsCn: {
				    title: '【中国国际线缆工业展览会】五大展馆，进阶出发！8月27日-29日与您相约上海！',
				    content: '2025年，WireShow 2025 规划5大展馆；多维度有针对性地组织海内外专业买家，围绕前沿热点，向行业呈现专业的新产品、新技术，提供更高品质的展会服务。',
					link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=83cace59-b879-432a-8c4b-0dab2b9077d2'
				  },
				  itemsEn: {
				    title: 'LOCK YOUR BOOTH RIGHT NOW! The 12th China International Wire and Cable Industry Exhibition (WireShow 2025) will be held in August. Grasp the Chinese market dynamics，connect with target customers efficiently, Optimize brand reputation！See you in Shanghai.',
				    content: 'In 2025, WireShow enters a new stage! We will bring a new experience for exhibit display, business matching, exhibition scale, and conference forums; We will efficiently promote the global market, and accurately organize professional buyers around world; Focusing on cutting-edge hotspots, we will present more professional and high-quality brand displays of new products, technologies, services, etc. We will focus on building an efficient supply chain and helping wire & cable industry companies enhance their brand competitiveness.',
					link: 'http://47.111.18.198/app/EditorPreview/TemplateGenerate.aspx?guid=ff5f0977-2e9e-4f5d-9791-604b878eaf0c'
				  },
				  updateTime: '2025-3-14',
				},
              // 可以添加更多静态数据
            ]
    }
  },
  computed: {
    // Filter EDM data based on current language
    filteredEDMData() {
      return this.listDataEDM.filter(item => {
        const currentLangData = item[this.$language === 'ZH' ? 'itemsCn' : 'itemsEn']
        return currentLangData && (currentLangData.title || currentLangData.content)
      })
    }
  },
  created() {
    this.getNewList()
    this.getFocusList()
  },
  watch: {
    '$language'(newLang, oldLang) {
      if (newLang !== oldLang) {
        // 切换语言后回到第 1 页重新拉取(过滤条件依赖语言,需重拉全量)
        this.newPageNo = 1
        this.focusPageNo = 1
        if (this.tabIndex === 0) {
          this.getNewList()
        } else if (this.tabIndex === 1) {
          this.getFocusList()
        }
      }
    }
  },
  methods: {
    // 展会最新
    getNewList() {
      this.loadingNew = true
      // 一次性拉到运营可发布的全量数据,客户端按语言过滤并分页,保证每页条数稳定
      this.$axios.get(queryArticlePageList + `?categoryId=1776862661877743617&pageNo=1&pageSize=1000`, {}).then(res => {
        this.loadingNew = false
        if (res.data.success) {
          this.allListDataNew = (res.data.result.records || []).filter(item => {
            const currentLangData = item[this.$language === 'ZH' ? 'itemsCn' : 'itemsEn']
            return currentLangData && currentLangData.title
          })
          this.newTotal = this.allListDataNew.length
          this.updateNewPageData()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(() => {
        this.loadingNew = false
      })
    },
    updateNewPageData() {
      const start = (this.newPageNo - 1) * this.newPageSize
      this.listDataNew = this.allListDataNew.slice(start, start + this.newPageSize)
    },
    async handleNewPageChange(pageNo, pageSize) {
      await nextTick(() => {
        this.newPageNo = pageNo
        this.newPageSize = pageSize
      })
      this.updateNewPageData()
    },
    // 行业聚焦
    getFocusList() {
      this.loadingFocus = true
      // 一次性拉到运营可发布的全量数据,客户端按语言过滤并分页,保证每页条数稳定
      this.$axios.get(queryArticlePageList + `?categoryId=1776862725224316930&pageNo=1&pageSize=1000`, {}).then(res => {
        this.loadingFocus = false
        if (res.data.success) {
          this.allListDataFocus = (res.data.result.records || []).filter(item => {
            const currentLangData = item[this.$language === 'ZH' ? 'itemsCn' : 'itemsEn']
            return currentLangData && currentLangData.title
          })
          this.focusTotal = this.allListDataFocus.length
          this.updateFocusPageData()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(() => {
        this.loadingFocus = false
      })
    },
    updateFocusPageData() {
      const start = (this.focusPageNo - 1) * this.focusPageSize
      this.listDataFocus = this.allListDataFocus.slice(start, start + this.focusPageSize)
    },
    async handleFocusPageChange(pageNo, pageSize) {
      await nextTick(() => {
        this.focusPageNo = pageNo
        this.focusPageSize = pageSize
      })
      this.updateFocusPageData()
    },
handleEDMClick(item) {
      try {
        const link = item[this.$language === 'ZH' ? 'itemsCn' : 'itemsEn'].link;
        if (!link) {
          console.error('链接不存在');
          return;
        }
        
        // 确保链接有协议头
        let finalLink = link;
        if (!/^https?:\/\//i.test(link)) {
          finalLink = `https://${link}`;
        }
        
        // 新窗口打开链接
        const newWindow = window.open(finalLink, '_blank');
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          // 如果弹窗被拦截，改为当前窗口跳转
          window.location.href = finalLink;
        }
      } catch (e) {
        console.error('打开链接失败:', e);
        this.$message.error(this.$t('h.dynamic.linkError'));
      }
    },

    tabChange(index) {
      this.tabData.forEach((item, i) => {
        if (index == i) {
          item.select = true
        } else {
          item.select = false
        }
      })
      this.tabIndex = index
      if (index === 0) {
        this.getNewList()
      } else if (index === 1) {
        this.getFocusList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.myPagination {
  ::v-deep .ant-pagination-item-active {
    border-color: #d7000F;
    background-color: #d7000F;

    a {
      color: #fff;
    }
  }
}
</style>
